import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LearningSystemService {
    private _learningSystemUrl = new BehaviorSubject<string>(
        environment.learningSystemUrl
    );

    get learningSystemUrl$(): Observable<string> {
        return this._learningSystemUrl.asObservable();
    }

    set learningSystemUrl$(url: string) {
        this._learningSystemUrl.next(url);
    }

    constructor() {}
}
